/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsCustomCreateType from '@jira/spa-apps__servicedesk-reports-custom-create/src/ServicedeskReportsCustomCreateType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskReportsCustomCreate: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskReportsCustomCreateType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-reports-custom-create", jiraSpaEntry: "async-servicedesk-reports-custom-create" */ '@jira/spa-apps__servicedesk-reports-custom-create/src/ServicedeskReportsCustomCreateType.tsx'
			),
		),
	);

const AsyncServicedeskReportsCustomCreate = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskReportsCustomCreate}
		pageId="spa-apps/servicedesk/reports/custom/create"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskReportsCustomCreate;
